package com.veldekar.components.logs

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*
import com.veldekar.components.widgets.LocalizedSessionDate
import com.veldekar.components.widgets.InvertibleImage

@Composable
fun Log_2026_02_21_Day_1() {
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("We return to our heroes who are sailing from Freeburg to Kostigan across the Sea of Indifference. Bigglesworth catches a 25-pound sailfish, which Zen takes to the galley to cook. Captain Leah L’Seth and Zen wear scarves to protect against the oppressive sun on the open sea. Leah asks the heroes about their plans after docking in Kostigan. Bigglesworth mentions a secret mission. Leah and the crew are picking up a shipment of lumber and returning to Freeburg. Bigglesworth mentions fighting demons. “The Cloud Chaser” doesn’t carry cannons, but she is very fast; Leah says they try to avoid trouble, including demons.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("At night, Tuesday and Caper hear something and spot a creature 60 feet port quarter. It appears to be a Merrow, an aquatic humanoid. Tuesday casts Comprehend Languages.")
    }
    com.varabyte.kobweb.silk.components.display.Callout(type = com.varabyte.kobweb.silk.components.display.CalloutType.QUOTE, label = null, variant = com.varabyte.kobweb.silk.components.display.CalloutDefaults.Variant) {
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.Text(" We must advance so the others can advance from the other side.")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Caper wakes the crew, and Tuesday flies up 30 feet and sees")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("a Nalfeshnee, a flying demon, and")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("a Marilith, a six-armed demon")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("approaching the bow. Tuesday hastened himself and Caper. Annette hastened Bigglesworth. Bigglesworth rushes to the main deck and goes wild on the Nalfeshnee. Korvis air shapes and attacks the Marilith. The Nalfeshnee emits a scintillating, multicolored light that frightens Bigglesworth and Korvis.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Meanwhile, Caper and Tuesday are defending the aft quarter from four Merrow. Dirk climbs to the main deck and chain lightnings the Merrow. He hopes his bravery and skill have impressed Leah (it has not). Tuesday burns up the remaining Merrow.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Zen finishes off the Nalfeshnee. The Marilith says “I’ll be back, my prized little ones.” before teleporting away. Tuesday thinks the Marilith hasn’t gone far. Falorn yells, “Marilith off the starboard bow.” Annette finishes off the Marilith with a fireball.")
    }
}
